import { makeStyles, TableSortLabel } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  cell: {
    fontSize: "14px",
    letterSpacing: "0.17px",
    lineHeight: "143%",
    padding: "14px 10px",
    height: "52px",
    display: "table-cell",

    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
  },

  balance1: {
    color: "rgba(0,0,0,0.87)",
    whiteSpace: "nowrap",
    letterSpacing: "0.17px",
    lineHeight: "24px",
  },
  balance2: {
    fontWeight: 500,
  },
  leftbox: {

    display: "flex",
  flex: "1 0 0",
    flexDirection: "row",

  },
  rightbox: {
    display: "flex",
  flex: "1 0 0",
    flexDirection: "row",
  },
    flexContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
  },
  flexOne: {
    flex: "1 0 0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  
}));
